
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `将其添加到主屏幕，以享受更丰富的体验并便于访问。`,
's224cbcec014ef6b5': `点击导航栏中的“分享”按钮`,
's37a9e8aec5713460': `更多`,
's386eca8362ff6155': `如果没有分享图标，请点击更多`,
's4e1e10a6ca408245': `轻触“添加到主屏幕”`,
's6196153c4b0c1ea0': `安装`,
's633502f7cff4f847': `打开浏览器菜单`,
's681e399d63311fba': `显示图库`,
's7f0591f08e318eda': `在分享菜单中点击更多`,
's8114bd55cae5a22b': `点击“添加到程序坞”`,
's922329d6f6213590': `添加到程序坞`,
's9af56bf005b49c74': `向下滚动至“添加到主屏幕”`,
'sa5ef80b4bb9b39f8': `收起`,
'sba52286c21552a4e': `在您的设备上安装，以享受更丰富的体验并便于访问。`,
'sc16e00a7a8b2fde2': `返回`,
'scdaf4bbff76674c8': `添加到主屏幕`,
'se0e473adfda8066c': `在您的主浏览器中打开`,
'se740f75b95a51807': `将其添加到您的程序坞，以享受更全面的体验并便于访问。`,
'sfea652f6580ff086': `此网站具备 App 功能特性。`,
    };
  